import { ROAD_CONNECT_E, ROAD_CONNECT_N, ROAD_CONNECT_S, ROAD_CONNECT_W } from "./roadConnectivity";

export type RoadAutotileKind = "straight" | "corner" | "tjunction" | "crossing" | "deadend";

const AUTOTILE_STRAIGHT_CANONICAL = ROAD_CONNECT_N | ROAD_CONNECT_S;
const AUTOTILE_CORNER_CANONICAL = ROAD_CONNECT_S | ROAD_CONNECT_E;
const AUTOTILE_T_JUNCTION_CANONICAL = ROAD_CONNECT_N | ROAD_CONNECT_S | ROAD_CONNECT_E;
const AUTOTILE_DEADEND_CANONICAL = ROAD_CONNECT_S;

function connectionCount(mask: number): number {
  let count = 0;
  if (mask & ROAD_CONNECT_N) count += 1;
  if (mask & ROAD_CONNECT_E) count += 1;
  if (mask & ROAD_CONNECT_S) count += 1;
  if (mask & ROAD_CONNECT_W) count += 1;
  return count;
}

export function rotateMaskClockwise(mask: number): number {
  let rotated = 0;
  if (mask & ROAD_CONNECT_N) rotated |= ROAD_CONNECT_E;
  if (mask & ROAD_CONNECT_E) rotated |= ROAD_CONNECT_S;
  if (mask & ROAD_CONNECT_S) rotated |= ROAD_CONNECT_W;
  if (mask & ROAD_CONNECT_W) rotated |= ROAD_CONNECT_N;
  return rotated;
}

function rotateMaskBy(mask: number, degrees: number): number {
  const steps = ((degrees / 90) | 0) % 4;
  let rotated = mask;
  for (let i = 0; i < steps; i++) rotated = rotateMaskClockwise(rotated);
  return rotated;
}

function matchRotation({
  kind,
  canonicalMask,
  mask,
}: {
  kind: RoadAutotileKind;
  canonicalMask: number;
  mask: number;
}): { kind: RoadAutotileKind; rotation: number } {
  for (const rotation of [0, 90, 180, 270]) {
    if (rotateMaskBy(canonicalMask, rotation) === mask) return { kind, rotation };
  }
  return { kind: "straight", rotation: 0 };
}

export function classifyRoadAutotile(mask: number): {
  kind: RoadAutotileKind;
  rotation: number;
} {
  const count = connectionCount(mask);
  if (count === 0) return { kind: "straight", rotation: 0 };
  if (count === 4) return { kind: "crossing", rotation: 0 };
  if (count === 3) {
    return matchRotation({
      kind: "tjunction",
      canonicalMask: AUTOTILE_T_JUNCTION_CANONICAL,
      mask,
    });
  }
  if (count === 2) {
    const isStraight =
      mask === (ROAD_CONNECT_N | ROAD_CONNECT_S) || mask === (ROAD_CONNECT_E | ROAD_CONNECT_W);
    if (isStraight) {
      return matchRotation({
        kind: "straight",
        canonicalMask: AUTOTILE_STRAIGHT_CANONICAL,
        mask,
      });
    }
    return matchRotation({ kind: "corner", canonicalMask: AUTOTILE_CORNER_CANONICAL, mask });
  }
  return matchRotation({ kind: "deadend", canonicalMask: AUTOTILE_DEADEND_CANONICAL, mask });
}
